import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IAuthRepository } from '../../repositories/interfaces/iAuthRepository';
import { clearLocalDataOnLogout } from '../../../../utils/refreshAuthTokenApi';
export interface ILogoutUseCase {
    execute(
        username: string,
        authToken: string,
        identityToken: string,
        authSign: string,
        apiToken: { [key: string]: string }
    ): Promise<boolean>;
}

export class LogoutUseCase implements ILogoutUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get authRepo(): IAuthRepository {
        return container.resolve<IAuthRepository>(DI.REPOSITORIES.IAuthRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        username: string,
        authToken: string,
        identityToken: string,
        authSign: string,
        apiToken: { [key: string]: string }
    ): Promise<boolean> {
        try {
            const response = await this.authRepo.logout(username, authToken, identityToken, authSign, apiToken);
            if (response?.success) {
                clearLocalDataOnLogout();
                return true;
            }
            return false;
        } catch (err: any) {
            console.error(err);
            throw err;
        }
    }
}
